import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CompanyService } from '../../services/company.service';
import { ModalComponent } from 'src/app/core/components/modal/modal.component';
import { CompanyListRefresh } from '../../services/company-list.refresh';
import { NotificationType } from 'src/app/core/models/ui-notification.model';
import { UINotificationService } from 'src/app/core/services/ui-notification.service';
import { TariffDetail } from '../../models/tariff-detail.model';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PasswordConfirmValidator } from '../../forms/user-form/password-confirm.validator';

@Component({
  selector: 'app-create-company',
  templateUrl: './create-company.component.html',
  styleUrls: ['./create-company.component.css']
})
export class CreateCompanyComponent {

  form = new FormGroup({});
  tariffs: TariffDetail[] = [];

  constructor(
    private companyService: CompanyService,
    private companyListRefresh: CompanyListRefresh,
    private uiNotificationService: UINotificationService,
    private route: ActivatedRoute,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    const response = this.route.snapshot.data.tariffs;
    this.tariffs = response.body;
    const defaultTariffCode = this.tariffs[0].code;

    this.form.addControl('company', new FormGroup({
      name: new FormControl('', Validators.required),
      ico: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]),
      tariff: new FormControl(defaultTariffCode, Validators.required),
    }));

    this.form.addControl('address', new FormGroup({
      street: new FormControl('', Validators.required),
      town: new FormControl('', Validators.required),
      zipcode: new FormControl('', [Validators.required, Validators.minLength(5)]),
      country: new FormControl('CZ', Validators.required)
    }));

    this.form.addControl('user', new FormGroup({
      name: new FormControl('', Validators.required),
      surname: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.email]),
      phone: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      confirmPassword: new FormControl('', Validators.required)
    }, PasswordConfirmValidator.passwordMatch));
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  onSubmit(modal: ModalComponent) {

    if (this.form.valid) {
      this.companyService.create({
        companyName: this.form.get('company.name').value,
        ico: this.form.get('company.ico').value,
        tariffCode: this.form.get('company.tariff').value,
        street: this.form.get('address.street').value,
        town: this.form.get('address.town').value,
        zipcode: this.form.get('address.zipcode').value,
        country: this.form.get('address.country').value,
        userName: this.form.get('user.name').value,
        userSurname: this.form.get('user.surname').value,
        userEmail: this.form.get('user.email').value,
        userPhone: this.form.get('user.phone').value,
        userPassword: this.form.get('user.password').value,
        permissionType: 1
      }).subscribe(() => {
        this.companyListRefresh.refresh();
        this.uiNotificationService.add({
          type: NotificationType.Success,
          message: 'Firma byla úspěšně přidána.'
        });
        modal.closeModal(null);
      });
    }
  }

}
